import { useEffect, useState, useCallback } from 'react';
import { homeAPI } from 'src/api/home-api';
import { OptionModel } from 'src/types/api-response';

export default function useCaySamFilterOptions() {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  
  const [options, setOptions] = useState({
    tinhTrang: [] as OptionModel[],
    diemSucKhoe: [] as OptionModel[],
    tuoiCay: [] as OptionModel[],
  });

const loadOptions = useCallback(async () => {
    setLoading(true);
    try {
      console.log("--- 🚀 Khởi chạy gọi API ---");
      const [tinhTrangRes, diemRes, tuoicayRes] = await Promise.all([
        homeAPI.OptionCaySamTinhTrang(),
        homeAPI.OptionCaySamDiemSucKhoe(),
        homeAPI.OptionLoSamLoaiTuoi(),
      ]);
      setOptions({
        tinhTrang: tinhTrangRes.items || [],
        diemSucKhoe: diemRes.items || [],
        tuoiCay: tuoicayRes.items || [], 
      });

    } catch (e: any) {
      console.error("❌ Lỗi thực thi Hook:", e);
      setError(e?.message || 'Lỗi tải dữ liệu');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadOptions();
  }, [loadOptions]);
 
  useEffect(() => {
    loadOptions();
  }, [loadOptions]);

  // Bảo vệ hàm helper khỏi việc crash khi options chưa load xong
  const getTuoiText = useCallback((id?: number | string) => {
    if (id === undefined || id === null) return '';
    const list = options.tuoiCay || [];
    const found = list.find((o) => String(o.value) === String(id));
    return found?.text || `ID: ${id}`;
  }, [options.tuoiCay]);

  const getTrangThaiText = useCallback((id?: number | string) => {
    if (id === undefined || id === null) return '';
    const list = options.tinhTrang || [];
    const found = list.find((o) => String(o.value) === String(id));
    return found?.text || `ID: ${id}`;
  }, [options.tinhTrang]);
  const getSucKhoeText = useCallback((id?: number | string) => {
    if (id === undefined || id === null) return '';
    const list = options.diemSucKhoe || [];
    const found = list.find((o) => String(o.value) === String(id));
    return found?.text || `ID: ${id}`;
  }, [options.diemSucKhoe]);

  return {
    loading,
    error,
    tinhTrangOptions: options.tinhTrang,
    diemSucKhoeOptions: options.diemSucKhoe,
    tuoicayOptions: options.tuoiCay,
    getTuoiText,
    getTrangThaiText,
    getSucKhoeText,
    refresh: loadOptions
  };
} 